import { event, GtagEvent } from "./event";
import { Item } from "./item";

export interface SelectPromotion extends GtagEvent {
    creative_name?:string;
    creative_slot?:string;
    promotion_id?:string;
    promotion_name?:string;
    items?:Item[];
}
export const select_promotion = ($_?:SelectPromotion) => event('select_promotion',$_);